import { render } from "./ScholarshipCard.vue?vue&type=template&id=06b7b8f0&scoped=true&ts=true"
import script from "./ScholarshipCard.vue?vue&type=script&lang=ts"
export * from "./ScholarshipCard.vue?vue&type=script&lang=ts"

import "./ScholarshipCard.vue?vue&type=style&index=0&id=06b7b8f0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06b7b8f0"]])

export default __exports__